import type { FromModel, ModelDefinition } from "@/__main__/data-model.mjs";
import { Union } from "@/__main__/data-model.mjs";
import { basePaymentMethodModel } from "@/feature-wallet/models/any-payment-method.mjs";
import type { PayPalPaymentMethod } from "@/feature-wallet/models/paypal-payment-method.mjs";
import { paypalPaymentMethodModel } from "@/feature-wallet/models/paypal-payment-method.mjs";
import type { StripeCardPaymentMethod } from "@/feature-wallet/models/stripe-card-payment-method.mjs";
import { stripeCardPaymentMethodModel } from "@/feature-wallet/models/stripe-card-payment-method.mjs";

/**
 * Used as a fallback if the payment method type cannot be determined.
 */
const unknownPaymentMethodModel = {
  ...basePaymentMethodModel,

  providerType: "UNKNOWN" as const,
  type: "unknown" as const,
} satisfies ModelDefinition;

export interface UnknownPaymentMethod
  extends FromModel<typeof unknownPaymentMethodModel> {}

export const paymentMethodModel = Union([
  stripeCardPaymentMethodModel,
  paypalPaymentMethodModel,
  unknownPaymentMethodModel,
]);

export type PaymentMethod =
  | StripeCardPaymentMethod
  | PayPalPaymentMethod
  | UnknownPaymentMethod;
